<!--
  Modern Register Screen (PrimeNG 19)
  - Fixed logo size
  - Angular v17 control flow (@if)
  - PrimeNG components for a polished design
-->

<!-- ===== Brand / Logo area ===== -->
<header class="brand" id="register-logo">
  <div class="brand__logo-wrapper">
    <img class="brand__logo" [src]="logoUrl" alt="Brand logo" />
  </div>
</header>

<!-- ===== Main content ===== -->
<section class="register">

  <!-- ================= NOT YET CREATED ================= -->
  @if (!accountCreated && subscriptionStatus !== 'expired') {
    <p-card class="register__card">
      <ng-template pTemplate="header">
        <div class="card__header">
          <h1 class="card__title"><i class="pi pi-user-plus"></i>&nbsp;Crear una cuenta</h1>
          <p class="card__subtitle">Todos los campos son obligatorios</p>
        </div>
      </ng-template>

      <div class="card__body mb-3">

        <!-- Errors block (username / email) -->
        @if (!errors.usernameIsValid || !errors.emailIsValid) {
          <p-message severity="error" class="mb-3">
              <div class="error-list">
                @if (!errors.usernameIsValid) {
                  <div class="error-item">
                    <i class="pi pi-times-circle"></i>
                    @if (appName === 'agrogestSIEX') {
                      <span>La dirección de email ya está en uso o es incorrecta.</span>
                    } @else {
                      <span>El nombre de usuario ya está en uso.</span>
                    }
                  </div>
                }
                @if (!errors.emailIsValid) {
                  <div class="error-item">
                    <i class="pi pi-times-circle"></i>
                    <span>La dirección de email ya está en uso o es incorrecta.</span>
                  </div>
                }
              </div>
          </p-message>
        }

        <!-- ===== Account data ===== -->
        <section class="block">
          <div class="block__title">
            <i class="pi pi-id-card"></i>
            <h2>Datos de la cuenta</h2>
          </div>

          <div class="block__content">
            <!--
              Using your Form Builder as-is to keep business logic untouched.
              We wrap it in a styled fieldset to match the modern look.
            -->
            <app-form-builder
              [model]="model"
              [distributionColumns]="1"
              [fields]="formFieldsAccount"
              (formChanges)="formChanges($event)">
            </app-form-builder>

            <app-form-builder
              [model]="model"
              [distributionColumns]="2"
              [fields]="formFieldsPassword"
              (formChanges)="formChanges($event)">
            </app-form-builder>
          </div>
        </section>

        <div class="block__title mt-5">
          <i class="pi pi-user"></i>
          <h2>Datos personales</h2>
        </div>

        <!-- ===== Personal data ===== -->
        <section class="block">
          <div class="block__content">
              <app-form-builder
                [model]="model"
                [distributionColumns]="2"
                [fields]="formFieldsLeft"
                (formChanges)="formChanges($event)">
              </app-form-builder>
          </div>
        </section>

        <!-- ===== Actions ===== -->
        <div class="actions">
          <p-button
            label="Volver" 
            icon="pi pi-arrow-left" 
            styleClass="p-button-outlined p-button-secondary p-button-rounded"
            (onClick)="goBack()">
          </p-button>

          <p-button
            label="Continuar"
            icon="pi pi-check"
            (onClick)="register()"
            [disabled]="!errors.usernameIsValid || !errors.emailIsValid"
            styleClass="p-button-success p-button-rounded">
          </p-button>
        </div>
      </div>
    </p-card>
  }

  <!-- ================= CREATED FEEDBACK ================= -->
  @if (accountCreated || subscriptionStatus === 'expired') {
    <p-card class="register__card">
      <ng-template pTemplate="header">
        <div class="card__header">
          @if (subscriptionStatus === 'expired') {
            <h1 class="card__title">El periodo de prueba se ha expirado</h1>
          } @else {
            <h1 class="card__title"><i class="pi pi-check-circle"></i>&nbsp;Usuario registrado</h1>
          }
        </div>
      </ng-template>

      <div class="card__body">
        @if (appName !== 'agrogestSIEX') {
          <p-message severity="success" class="mb-3"
                    text="Ha sido registrado con éxito. Se le notificará vía email cuando un administrador valide su cuenta.">
          </p-message>
        }
        <div class="actions">          
          @if (appName === 'agrogestSIEX') {
            <!-- Monthly payment -->
            <stripe-buy-button #monthlySubscriptionButton
              buy-button-id="buy_btn_1ST3iuKUqQctcg5lboToS0Sz"
              publishable-key="pk_live_4JKZu3Vp77Vypwwz7jMNoqcH"
              customer-email=""
            >
            </stripe-buy-button>

            <!-- Annual payment -->
            <stripe-buy-button #annualSubscriptionButton
              buy-button-id="buy_btn_1SBaEtKUqQctcg5lrZ5QFB7q"
              publishable-key="pk_live_4JKZu3Vp77Vypwwz7jMNoqcH"
              customer-email=""
            >
            </stripe-buy-button>
        }
        </div>
        @if (subscriptionStatus !== 'expired') {
          <div class="hr-lines">o</div>          
          <div class="mt-3 d-flex justify-content-center">
            <p-button
              label="Empezar prueba gratuita de 7 dias"
              (onClick)="goBack()"
              styleClass="p-button-rounded"
              [ngClass]="appName === 'agrogestSIEX' ? 'trial-button' : 'return-button'"
              >
            </p-button>        
          </div>
        }
      </div>
    </p-card>
  }
</section>
